<template>
  <div class="myOrder">
    <orderDetail @backAndClose='backAndClose' v-if="orderDetailShow" :orderNo='orderNoDetail'></orderDetail>
    <div class="app-container calendar-list-container" v-else>
      <div class="title">{{$t('MyOrder.OrderCenter')}}</div>
      <div class="tab-box">
        <span :class="currentIndex===0?'active':''" @click="handleTab(0)">{{$t('MyOrder.All')}}</span>
        <span :class="currentIndex===1?'active':''" @click="handleTab(1)">{{$t('MyOrder.Completed')}}</span>
        <span :class="currentIndex===2?'active':''" @click="handleTab(2)">{{$t('MyOrder.ToBePaid')}}</span>
      </div>
      <el-form :model="listQuery" ref="form" class="search-form-inline" label-width="100px">
        <el-row :gutter="15">
          <el-col :span="5">
            <el-form-item :label="$t('MyOrder.OrderNumber')" prop="orderNo">
              <el-input clearable v-model="listQuery.orderNo" :placeholder="$t('MyOrder.OrderNumber')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('MyOrder.VisitorIDNumber')" prop="visitorCertificateNo">
              <el-input clearable v-model="listQuery.visitorCertificateNo" :placeholder="$t('MyOrder.VisitorIDNumber')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('MyOrder.Contactphonenumber')" prop="contactMobile">
              <el-input clearable v-model="listQuery.contactMobile" :placeholder="$t('MyOrder.Contactphonenumber')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('MyOrder.VisitTime')" prop="orderTime"
              :rules="[
                {
                  required: true,
                  message:  `${$t('MyOrder.selectVisitTime')}`,
                  trigger: ['blur', 'change'],
                },
              ]">
              <!-- <el-date-picker clearable class="w50" v-model="listQuery.orderTime" type="datetimerange" range-separator="至" format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    :start-placeholder="$t('MyOrder.Startdate')"
                    :end-placeholder="$t('MyOrder.EndDate')"
                    @change="flage++"
                    style="width:100%;"
                    >
              </el-date-picker> -->
              <el-date-picker
              :clearable="false"
              v-model="listQuery.orderTime"
              type="date"
              style="width:100%;"
              :placeholder="`${$t('MyOrder.selectVisitTime')}`"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">>
            </el-date-picker>
              <input hidden :value="flage"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="text-align:center;">
          <el-button @click="getList" type="primary">{{$t('MyOrder.Inquire')}}</el-button>
          <el-button @click="reset('form')">{{$t('MyOrder.Reset')}}</el-button>
        </el-row>
      </el-form>
      <el-table class="order-table" :default-expand-all='true' :key='tableKey' :data='list' v-loading.body='listLoading' fit highlight-current-row style='width: 100%'>
          <el-table-column class="s1" align='center' :label="$t('MyOrder.OrderNumber')">
              <template slot-scope='scope'>
                  <span>{{scope.row.orderNo}}</span>
              </template>
          </el-table-column>
          <el-table-column align='center' :label="$t('MyOrder.OrderPlacementTime')">
              <template slot-scope='scope'>
                  <span>{{scope.row.orderTime}}</span>
              </template>
          </el-table-column>
          <el-table-column align='center' :label="$t('MyOrder.Contactphonenumber')">
              <template slot-scope='scope'>
                  <!-- <span>{{scope.row.contactMobile}}</span> -->
                  <span class="flex-center">
                  <span v-if="scope.row.contactMobile2">{{ scope.row.contactMobile2 }}</span>
                  <span v-else>{{ scope.row.contactMobile }}</span>
                  <i
                    v-if="scope.row.contactMobile && scope.row.contactMobile2 && scope.row['contactMobile' +'Encrypt']"
                    class="el-icon-view viewOperate blue pointer"
                    @click="decrypt(scope.row, 'contactMobile')"
                  />
                  <i
                    v-if="scope.row.contactMobile && !scope.row.contactMobile2 && scope.row['contactMobile' +'Encrypt']"
                    class="el-icon-view viewOperate closed pointer"
                    @click="decrypt(scope.row, 'contactMobile')"
                  />
              </span>
              </template>
          </el-table-column>
          <el-table-column align='center' :label="$t('MyOrder.OrderStatus')">
              <template slot-scope='scope'>
                  <span v-if="scope.row.status === '-1'">{{$t('orderStatus.Closed')}}</span>
                  <span v-if="scope.row.status === '20'">{{$t('orderStatus.Tobepaid')}}</span>
                  <span v-if="scope.row.status === '10'">{{$t('orderStatus.Pendingreview')}}</span>
                  <span v-if="scope.row.status === '30'">{{$t('orderStatus.Issued')}}</span>
                  <span v-if="scope.row.status === '50'">{{$t('orderStatus.Refunded')}}</span>
                  <span v-if="scope.row.status === '60'">{{$t('orderStatus.Completed')}}</span>
                  <span v-if="scope.row.status === '40'">{{'部分退款'}}</span>
              </template>
          </el-table-column>
          <el-table-column type="expand" :label="$t('MyOrder.Expandall')" width="100">
          <template slot-scope="scope">
            <el-table :span-method="objectSpanMethod" :show-header="true" :data="scope.row.tripOrderDetailDOList" style="width: 100%" fit border>
              <el-table-column align='center' prop="ticketName" :label="$t('buyTicket.productName')"></el-table-column>
              <el-table-column align='center' prop="ticketKindName" :label="$t('buyTicket.ticketType')"></el-table-column>
              <el-table-column align='center' prop="currentSalePrice" :label="$t('buyTicket.UnitPrice')"></el-table-column>
              <el-table-column align='center' prop="quantity" :label="$t('buyTicket.Quantity')"></el-table-column>
              <el-table-column align='center' :label="$t('MyOrder.Visitdate')">
                  <template slot-scope='subscope'>
                      <span>{{subscope.row.startDate}}</span>
                  </template>
              </el-table-column>
              <el-table-column align='center' :label="$t('MyOrder.VisitTimePeriod')">
                  <template slot-scope='subscope'>
                      <span>{{subscope.row.reservationBeginTime}} - {{subscope.row.reservationEndTime}}</span>
                  </template>
              </el-table-column>
              <el-table-column align='center' :label="$t('MyOrder.Actualpaymentpaymentmethod')">
                  <span>￥{{scope.row.paymentTotal}}</span>
                  <span v-if="scope.row.payWayName">（{{scope.row.payWayName}}）</span>
              </el-table-column>
              <el-table-column align='center' width='220px' :label="$t('MyOrder.Operating')">
                <el-row :gutter="10" class="btns">
                  <el-col tag="span" :span="btnCanShowList(scope,-1)" v-if="btnCanShowList(scope,0)"><span class='blue cursor pointer' @click="hanleToDetail(scope.row.orderNo)">{{$t('MyOrder.OrderDetails')}} </span></el-col>
                  <el-col tag="span" :span="btnCanShowList(scope,-1)" v-if="btnCanShowList(scope,1)"><span class='blue cursor pointer' @click="hanleToDetail(scope.row.originalOrderNo)">查看原单 </span></el-col>
                  <el-col tag="span" :span="btnCanShowList(scope,-1)" v-if="btnCanShowList(scope,2)"><span class='blue cursor pointer' @click="hanleToPay(scope.row.orderNo,scope.row)">{{$t('MyOrder.Paymentquery')}}</span></el-col>
                  <el-col tag="span" :span="btnCanShowList(scope,-1)" v-if="btnCanShowList(scope,3)"><span class='blue cursor pointer' @click="replenish(scope.row.orderNo)">{{$t('payOrder.TicketReplacement')}} </span></el-col>
                  <el-col tag="span" :span="btnCanShowList(scope,-1)" v-if="btnCanShowList(scope,4)"><span class='blue cursor pointer' @click="hanleToChageTicket(scope.row.orderNo)">{{$t('payOrder.ChangeTicket')}} </span></el-col>
                  <el-col tag="span" :span="btnCanShowList(scope,-1)" v-if="btnCanShowList(scope,5)"><span class='blue cursor pointer' @click="hanleToRefund(scope.row.orderNo)"> {{$t('payOrder.Refund')}}</span></el-col>
                  <el-col tag="span" :span="btnCanShowList(scope,-1)" v-if="btnCanShowList(scope,6)"><span class='blue cursor pointer' @click="hanleToReason(scope.row.remark)">查看原因</span></el-col>
                  <el-col tag="span" :span="btnCanShowList(scope,-1)" v-if="btnCanShowList(scope,7)"><span class='blue cursor pointer' @click="hanleReOrder(scope.row.orderNo)">重新下单</span></el-col>
                </el-row>
              </el-table-column>
            </el-table>
            </template>
          </el-table-column>
      </el-table>
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.page"
          :page-sizes="[10,20,30]"
          :page-size="listQuery.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :prev-text="$t('PreviousPage')"
          :next-text="$t('NextPage')"
          :total="total"
        ></el-pagination>
      </div>
      <el-dialog :title="$t('Refund')" left width="70%" :visible.sync="dialogCompVisible">
          <el-table header-row-class-name='parent-head-style' :key='tableKey' :data='tikcetInfoList' fit highlight-current-row @selection-change="handleSelectionChange" style='width: 100%'>
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column align='center' :label="$t('MyOrder.Ticketnumber')">
              <template slot-scope='scope'>
                <span>{{scope.row.ticketNo}}</span>
              </template>
            </el-table-column>
            <el-table-column align='center' :label="$t('FillOrder.productName')">
              <template slot-scope='scope'>
                <span>{{scope.row.ticketName}}</span>
              </template>
            </el-table-column>
            <el-table-column align='center' :label="$t('FillOrder.ticketType')">
              <template slot-scope='scope'>
                <span>{{scope.row.ticketKindName}}</span>
              </template>
            </el-table-column>
            <el-table-column align='center' :label="$t('status')">
              <template slot-scope='scope'>
                <span>{{scope.row.statusStr}}</span>
              </template>
            </el-table-column>
            <el-table-column align='center' :label="$t('FillOrder.Name')">
              <template slot-scope='scope'>
                <span class="flex-center">
                  <span v-if="scope.row.visitorName2">{{ scope.row.visitorName2 }}</span>
                  <span v-else>{{ scope.row.visitorName }}</span>
                  <i
                    v-if="scope.row.visitorName && scope.row.visitorName2 && scope.row['visitorName' +'Encrypt']"
                    class="el-icon-view viewOperate blue pointer"
                    @click="decrypt(scope.row, 'visitorName')"
                  />
                  <i
                    v-if="scope.row.visitorName && !scope.row.visitorName2 && scope.row['visitorName' +'Encrypt']"
                    class="el-icon-view viewOperate closed pointer"
                    @click="decrypt(scope.row, 'visitorName')"
                  />
                </span>
              </template>
            </el-table-column>
            <el-table-column align='center' :label="$t('FillOrder.IDNumber')">
              <template slot-scope='scope'>
                <span class="flex-center">
                  <span v-if="scope.row.visitorCertificateNo2">{{ scope.row.visitorCertificateNo2 }}</span>
                  <span v-else>{{ scope.row.visitorCertificateNo }}</span>
                  <i
                    v-if="scope.row.visitorCertificateNo && scope.row.visitorCertificateNo2 && scope.row['visitorCertificateNo' +'Encrypt']"
                    class="el-icon-view viewOperate blue pointer"
                    @click="decrypt(scope.row, 'visitorCertificateNo')"
                  />
                  <i
                    v-if="scope.row.visitorCertificateNo && !scope.row.visitorCertificateNo2 && scope.row['visitorCertificateNo' +'Encrypt']"
                    class="el-icon-view viewOperate closed pointer"
                    @click="decrypt(scope.row, 'visitorCertificateNo')"
                  />
                </span>
              </template>
            </el-table-column>
            <el-table-column align='center' :label="$t('MyOrder.Price')">>
              <template slot-scope='scope'>
                <span>{{scope.row.totalPrice}}</span>
              </template>
            </el-table-column>
            <el-table-column align='center' :label="$t('MyOrder.Handlingfee')">
              <template slot-scope='scope'>
                <span>{{scope.row.refundPoundage}}</span>
              </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <div class="footer-box">
              <div class="travel-refundTotal">
                <span v-if=isReplenishOrder class="travel-tip">温馨提示：订单支付时间不同，银行分批次退款，请耐心等待！</span>
                <span>
                   {{$t('MyOrder.selectText').replace(new RegExp('&item1'), selectionList.length)}} <span class="red">￥{{refunfPrice}}</span>（{{$t('MyOrder.selectText2')}} ￥{{refundPoundage}}）
                </span>
                <span v-if=isReplenishOrder class="travel-tip-right">{{$t('payOrder.TicketReplacement')}}：￥{{(refunfPrice-refundReplenishOriginPrice).toFixed(2)}} {{tikcetInfoList[0]&&tikcetInfoList[0].originTicketInfo.ticketKindName}}：￥{{refundReplenishOriginPrice}}</span>
              </div>
              <div class="footer-btn">
                <el-button v-if=!isReplenishOrder type="primary" @click="submitRefund">{{$t('payOrder.Refund')}}</el-button>
                <el-button v-if=isReplenishOrder type="primary" @click="submitReplenishRefund">{{$t('payOrder.Refund')}}</el-button>
              </div>
            </div>
          </div>
      </el-dialog>
      <el-dialog :title="$t('payOrder.ChangeTicket')" left width="70%" :visible.sync="dialogTicketVisible">
        <el-table header-row-class-name='parent-head-style' :key='tableKey' :data='tikcetOrderList' fit highlight-current-row @selection-change="handleSelectionTicketChange" style='width: 100%'>
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column align='center' :label="$t('MyOrder.Ticketnumber')">
            <template slot-scope='scope'>
              <span>{{scope.row.ticketNo}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' :label="$t('FillOrder.productName')">
            <template slot-scope='scope'>
              <span>{{scope.row.ticketName}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' :label="$t('FillOrder.ticketType')">
            <template slot-scope='scope'>
              <span>{{scope.row.ticketKindName}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label='状态'>
            <template slot-scope='scope'>
                <span v-if="scope.row.status === '-1'">{{$t('orderStatus.Closed')}}</span>
                <span v-if="scope.row.status === '20'">{{$t('orderStatus.Tobepaid')}}</span>
                <span v-if="scope.row.status === '10'">{{$t('orderStatus.Pendingreview')}}</span>
                <span v-if="scope.row.status === '30'">{{$t('orderStatus.Issued')}}</span>
                <span v-if="scope.row.status === '50'">{{$t('orderStatus.Refunded')}}</span>
                <span v-if="scope.row.status === '60'">{{$t('orderStatus.Completed')}}</span>
                <span v-if="scope.row.status === '40'">{{'部分退款'}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' :label="$t('FillOrder.Name')">
            <template slot-scope='scope'>
              <span class="flex-center">
                <span v-if="scope.row.visitorName2">{{ scope.row.visitorName2 }}</span>
                <span v-else>{{ scope.row.visitorName }}</span>
                <i
                  v-if="scope.row.visitorName && scope.row.visitorName2 && scope.row['visitorName' +'Encrypt']"
                  class="el-icon-view viewOperate blue pointer"
                  @click="decrypt(scope.row, 'visitorName')"
                />
                <i
                  v-if="scope.row.visitorName && !scope.row.visitorName2 && scope.row['visitorName' +'Encrypt']"
                  class="el-icon-view viewOperate closed pointer"
                  @click="decrypt(scope.row, 'visitorName')"
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column align='center' :label="$t('FillOrder.IDNumber')">
            <template slot-scope='scope'>
              <span class="flex-center">
                <span v-if="scope.row.visitorCertificateNo2">{{ scope.row.visitorCertificateNo2 }}</span>
                <span v-else>{{ scope.row.visitorCertificateNo }}</span>
                <i
                  v-if="scope.row.visitorCertificateNo && scope.row.visitorCertificateNo2 && scope.row['visitorCertificateNo' +'Encrypt']"
                  class="el-icon-view viewOperate blue pointer"
                  @click="decrypt(scope.row, 'visitorCertificateNo')"
                />
                <i
                  v-if="scope.row.visitorCertificateNo && !scope.row.visitorCertificateNo2 && scope.row['visitorCertificateNo' +'Encrypt']"
                  class="el-icon-view viewOperate closed pointer"
                  @click="decrypt(scope.row, 'visitorCertificateNo')"
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column align='center' :label="$t('FillOrder.SpecialIDNumber')">
            <template slot-scope='scope'>
              <span>{{scope.row.specialCertificate}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' :label="$t('MyOrder.Price')">
            <template slot-scope='scope'>
              <span>{{scope.row.totalPrice}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' :label="$t('MyOrder.Handlingfee')">
            <template slot-scope='scope'>
              <span>{{scope.row.refundPoundage}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitEndorse">{{$t('payOrder.ChangeTicket')}}</el-button>
        </div>
      </el-dialog>

      <el-dialog left width="70%" :visible.sync="dialogTimeVisible">
        <div class="div-ticket">
          <div class="buyticket-div">
            <span class="title">选择改签日期</span>
            <div class="buyticket-right">
              <div class="select-btn" style="margin: 0 7px">
                <span :class="valueDate?'picker-options active':'picker-options'">
                  <el-date-picker
                    :picker-options="pickerOptions"
                    v-model="valueDate"
                    format="MM月dd日"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="其他日期"
                    :editable="false"
                    :clearable="false"
                    @change="handleSaleDate"
                  ></el-date-picker>
                </span>
              </div>
              <div class="select-list">
                <span
                  @click="bindDateChange(item,index)"
                  v-for="(item,index) in date"
                  v-if="index<=2"
                  :key="index"
                >
                  <em
                    v-if="item.showDate"
                    :class="[item.selectTime?'active':'' , item.canReservationSanke==='F'  ? 'disable' : '']"
                    style="line-height: 34px"
                  >{{item.showDate[1]}}月{{item.showDate[2]}}日</em>
                </span>
              </div>
              <span
                v-show="!timeSharingSelect"
                class="time-select-text"
              >请选择日期和检票进场时段进行改签！</span>
            </div>
          </div>
          <div class="buyticket-div">
            <span class="title">{{$t('buyTicket.selectAVisitTime')}}</span>
            <div class="buyticket-right">
              <div class="select-list">
                <span
                  @click="radioChange(item)"
                  v-for="(item,index) in timeSharing"
                  :key="index"
                >
                  <em
                    :class="[item.isCheck?'active':'' , item.canReservationSanke === 'F' ? 'disable' : '']"
                  >
                    {{item.reservationBeginTime}}~{{item.reservationEndTime}}
                    <br />
                    {{$t('buyTicket.ticketBalance')}}：{{item.surplusStockNum}}
                  </em>
                </span>
              </div>
            </div>
          </div>
        </div>
          <div slot="footer" class="dialog-footer text-center">
            <el-button type="primary" @click="submitReBook">确认改签</el-button>
          </div>
      </el-dialog>
      <el-dialog
        :title="$t('payOrder.TicketReplacement')"
        :visible.sync=replenishDialogVisible
        width="90%"
        :show-close=true>
          <!-- 补票列表 -->
          <el-table
            :data=replenishList
            :border=true
            row-key="id"
            empty-text=" "
            :default-expand-all=true
            :header-cell-style="{backgroundColor: 'gray',color: '#222'}"
            v-loading="replenishListLoading"
            @selection-change=replenishChange
            >
              <el-table-column width="50px" align="center" type="selection"></el-table-column>
              <el-table-column
                :show-overflow-tooltip=true
                :label="$t('MyOrder.Ticketnumber')"
                align="center"
                prop="ticketNo"
                min-width="50px">
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip=true
                :label="$t('FillOrder.productName')"
                align="center"
                prop="replenishTicketName"
                min-width="50px">
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip=true
                :label="$t('FillOrder.ticketType')"
                align="center"
                prop="ticketKindName"
                min-width="50px">
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip=true
                :label="$t('status')"
                align="center"
                prop="ticketInfoStatus"
                min-width="50px">
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip=true
                :label="$t('FillOrder.Name')"
                align="center"
                prop="visitorName"
                min-width="50px">
                <template slot-scope='scope'>
                  <span class="flex-center">
                    <span v-if="scope.row.visitorName2">{{ scope.row.visitorName2 }}</span>
                    <span v-else>{{ scope.row.visitorName }}</span>
                    <i
                      v-if="scope.row.visitorName && scope.row.visitorName2 && scope.row['visitorName' +'Encrypt']"
                      class="el-icon-view viewOperate blue pointer"
                      @click="decrypt(scope.row, 'visitorName')"
                    />
                    <i
                      v-if="scope.row.visitorName && !scope.row.visitorName2 && scope.row['visitorName' +'Encrypt']"
                      class="el-icon-view viewOperate closed pointer"
                      @click="decrypt(scope.row, 'visitorName')"
                    />
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip=true
                :label="$t('FillOrder.IDNumber')"
                align="center"
                prop="visitorCertificateNo"
                min-width="50px">
                <template slot-scope='scope'>
                  <span class="flex-center">
                    <span v-if="scope.row.visitorCertificateNo2">{{ scope.row.visitorCertificateNo2 }}</span>
                    <span v-else>{{ scope.row.visitorCertificateNo }}</span>
                    <i
                      v-if="scope.row.visitorCertificateNo && scope.row.visitorCertificateNo2 && scope.row['visitorCertificateNo' +'Encrypt']"
                      class="el-icon-view viewOperate blue pointer"
                      @click="decrypt(scope.row, 'visitorCertificateNo')"
                    />
                    <i
                      v-if="scope.row.visitorCertificateNo && !scope.row.visitorCertificateNo2 && scope.row['visitorCertificateNo' +'Encrypt']"
                      class="el-icon-view viewOperate closed pointer"
                      @click="decrypt(scope.row, 'visitorCertificateNo')"
                    />
                  </span>
              </template>
            </el-table-column>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip=true
                :label="$t('FillOrder.SpecialIDNumber')"
                align="center"
                prop="specialCertificate"
                min-width="50px">
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip=true
                :label="$t('MyOrder.Price')"
                align="center"
                prop="replenishTicketPrice"
                min-width="50px">
                <template slot-scope="scope"><span>￥{{scope.row.replenishTicketPrice}}</span></template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip=true
                :label="$t('MyOrder.Handlingfee')"
                align="center"
                prop="name"
                min-width="50px">
                <template slot-scope="scope"><span>￥</span></template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip=true
                label="补票金额"
                align="center"
                prop="replenishTicketDiffPrice"
                min-width="50px">
                <template slot-scope="scope"><span>￥{{scope.row.replenishTicketDiffPrice}}</span></template>
              </el-table-column>
          </el-table>
          <div slot="footer" >
            <span style="margin-right: 20px;">{{$t('buyTicket.Total')}}: <span style="color: #cc7777;">￥{{sum(replenishSelectedList.map(item=>item.replenishTicketDiffPrice))}}</span></span>
            <el-button type="primary" :disabled="replenishSelectedList.length<=0" @click="payReplenish">{{$t('FillOrder.BuyNow')}}</el-button>
          </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { page, getTicketInfo, ticketReplenishRefund, ticketRefund, PayForTheQuery, findRebook, canReBook, isCanRebook, getReplenishList, saveReplenishOrder } from '@/api/myOrder'
import { reservationDaily, getPreSaleDays, reservationConfig, standByList } from '@/api/buyTicket'
import { dateFtt } from '../common/js/common'
import { config } from '@/constant/config'
import orderDetail from './orderDetail_2'
import { decryptMixin } from '@/mixins/decryptMixin'
export default {
  name: 'orderList',
  mixins: [decryptMixin],
  data () {
    return {
      list: [],
      flage: 0,
      ticketInfo: {},
      total: null,
      listLoading: false,
      listQuery: {
        limit: 10,
        page: 1,
        orderTime: dateFtt('yyyy-MM-dd', new Date())
      },
      tableKey: 0,
      dialogCompVisible: false,
      dialogTicketVisible: false,
      selectionList: [],
      selectionTicketList: [],
      tikcetOrderList: [],
      refunfPrice: 0,
      refundPoundage: 0,
      tikcetInfoList: [],
      refundReplenishOriginPrice: 0,
      date: [],
      isCanReBookFlag: null,
      valueDate: '',
      isTravelLogin: false,
      dialogTimeVisible: false,
      status: [],
      visitorCertificateNo: null,
      orderNo: null,
      customerList: null,
      timeSharing: [],
      selectDate: '',
      reOrderNo: null,
      orderNoDetail: null,
      orderDetailShow: false,
      timeSharingSelect: false,
      ReservationConfig: {},
      dateList: [],
      pickerOptions: {
        disabledDate (time) {
          const curDate = (new Date()).getTime()
          // 这里算出一个月的毫秒数,
          const day = 14 * 24 * 3600 * 1000
          const bday = 2 * 24 * 3600 * 1000
          const dateRegion = curDate + day
          return time.getTime() < curDate + bday ||
          time.getTime() > dateRegion
          // var times = Date.now() - 24 * 60 * 60 * 1000
          // return time.getTime() < times
        }
      },
      currentIndex: 0,
      replenishDialogVisible: false,
      replenishList: [],
      replenishListLoading: false,
      replenishSelectedList: [],
      isReplenishOrder: false
    }
  },
  created () {
    this.getList()
  },
  computed: {

  },
  components: {
    orderDetail
  },
  methods: {
    // 判断按钮是否显示
    btnCanShowList (scope, n) {
      let showList = Array(8).fill(false)
      if (true) {
        showList[0] = true
      }
      if (true && scope.row.isReplenishOrder === 'T') {
        showList[1] = true
      }
      if (true && scope.row.status === '20') {
        showList[2] = true
      }
      if (true && scope.row.canReplenish) {
        showList[3] = true
      }
      if (true && scope.row.status === '30' && scope.row.canRebook === true && this.isCanReBookFlag && this.isCanReBookFlag === 'T') {
        showList[4] = true
      }
      if (true && scope.row.status === '30' && scope.row.canRefund === true) {
        showList[5] = true
      }
      if (true && scope.row.status === '拒绝') {
        showList[6] = true
      }
      if (true && scope.row.status === '-2' && this.isTravelLogin) {
        showList[7] = true
      }
      let total = showList.filter(item => item).length
      if (n === -1) {
        if (total === 1) {
          return 24
        } else if (total % 2 === 0) {
          return 12
        } else {
          return null
        }
      } else {
        return showList[n]
      }
      if (n === -2) {
        return total
      }
    },
    replenishChange (val) {
      this.replenishSelectedList = val
    },
    sum (list) {
      let res = 0
      list.forEach(item => res += item)
      return res
    },
    selectFun (row, index) {
      return row.selectable
    },
    // 获取普通产品列表
    getPreSaleDays () {
      return new Promise((resolve, reject) => {
        getPreSaleDays().then(res => {
          if (res.code === 0) {
            let value = res.data.value || 10
            // 如果是全角数字需要转换
            if (value.match(/[\uff00-\uffff]/g)) {
              value = this.CtoH(value)
            }
            resolve(parseInt(value) + 1)
          } else if (res.code === 1017) {
            this.$message({
              message: '登录过期，安全性提醒：请重新登录',
              type: 'error'
            })
          } else {
            this.$message({
              message: res.error,
              type: 'error'
            })
            resolve(10)
          }
        })
      })
    },
    getIsCanReBook () {
      isCanRebook().then(res => {
        if (res.code === 0) {
          this.isCanReBookFlag = res.data.value
        }
      })
    },
    getstaggeredList () {
      let data = {
        reservationDate: this.selectDate,
        orgId: sessionStorage.getItem('orgId')
      }
      reservationDaily(data).then(res => {
        if (res.code === 0) {
          let timeSharing = []
          let data = res.data
          if (data.length > 0) {
            let ids = data.findIndex(value => value.canReservationSanke === 'T')
            data.forEach((item, index) => {
              item.reservationMsg = item.reservationBeginTime + '~' + item.reservationEndTime
              if (index === ids) {
                // item.isCheck = true
              } else {
                item.isCheck = false
              }
            })

            // 过滤指定预约时段
            if (config.filterReservationDaily) {
              const filterReservationDaily = config.filterReservationDaily.split('-')
              if (config.isShowFilterReservationDaily) {
                data = data.filter(item => {
                  return (item.reservationBeginTime === filterReservationDaily[0] && item.reservationEndTime === filterReservationDaily[1])
                })
              } else {
                data = data.filter(item => {
                  return (item.reservationBeginTime !== filterReservationDaily[0] && item.reservationEndTime !== filterReservationDaily[1])
                })
              }
            }
            timeSharing = data
            this.timeSharingIndex = ids
            this.timeSharing = timeSharing
            this.date.forEach(item => {
              delete item.selectTime
              if (item.isCheck) {
                item.selectTime = this.timeSharing[this.timeSharingIndex]
              }
            })
            this.getSelectTime()
          } else {
            this.timeSharingIndex = null
            this.timeSharing = []
          }
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    getSelectTime () {
      this.date.forEach(item => {
        if (item.isCheck) {
          this.selectTime = item.selectTime || {}
          this.selectTime.showDate = item.showDate
        }
      })
    },
    radioChange (data) {
      if (data.canReservationSanke === 'F') {
        this.$message({
          message: '该时段无预约票',
          type: 'error'
        })
        return false
      }
      this.timeSharing.forEach((item, index) => {
        item.isCheck = false
        if (item.id === data.id) {
          item.isCheck = true
          this.timeSharingIndex = index
          this.timeSharingSelect = true
        }
      })
    },
    // 日期框架选择日期
    handleSaleDate () {
      let selectDate = this.date.find(res => res.date === this.valueDate)
      if (!selectDate) {
        this.valueDate = this.selectDate
        this.date.forEach(i => {
          i.isCheck = false
          i.selectTime = false
        })
        this.$message({
          message: '该日期无预约票',
          type: 'error'
        })
        return false
      }
      if (selectDate.canReservationSanke === 'F') {
        let ids = this.date.findIndex((res, index) => (index <= 2 && res.date === this.valueDate))
        let idsi = this.date.findIndex((res, index) => index > 2 && res.date === this.selectDate)
        if (ids === -1) {
          this.valueDate = ''
        }
        if (idsi > -1) {
          this.valueDate = this.selectDate
        }
        this.$message({
          message: '该日期无预约票',
          type: 'error'
        })
        return false
      }
      this.date.forEach(i => {
        i.isCheck = false
        i.selectTime = false
      })
      this.timeSharingSelect = false
      this.selectDate = this.valueDate
      this.getstaggeredList()
    },
    // 日期点击选择
    bindDateChange (item, idx) {
      if (item.canReservationSanke === 'F') {
        this.$message({
          message: '该日期无预约票',
          type: 'error'
        })
        return false
      }
      this.date.forEach(i => {
        i.isCheck = false
        i.selectTime = false
        if (i.date === item.date) {
          i.isCheck = true
          i.selectTime = true
        }
      })
      if (item.date !== this.selectDate) {
        this.valueDate = ''
        this.selectDate = item.date
        this.ticketList = null
        this.timeSharingSelect = false
        this.getstaggeredList()
      }
    },
    // 改签
    hanleToChageTicket (orderNo) {
      this.$confirm('改签操作仅能发起一次，请确认是否改签', '提示', {
        showCancelButton: false,
        type: 'warning',
        confirmButtonText: '确定'
      }).then(() => {
        this.dialogTicketVisible = true
        const data = {
          orderNo
        }
        this.reOrderNo = orderNo
        findRebook(data).then(res => {
          if (res.code === 0) {
            this.tikcetOrderList = res.data
          } else {
            this.$message.error(res.error)
          }
        })
      })
    },
    handleSizeChange (value) {
      this.listQuery.limit = value
      this.listQuery.page = 1
      this.getList()
      console.log(value)
    },
    handleCurrentChange (value) {
      this.listQuery.page = value
      this.getList()
      console.log(value)
    },
    spanMethod ({ row, column, rowIndex, columnIndex }) {
      const len = this.list[row.fromSort].tripOrderDetailDOList.length
      if (columnIndex === 4 || columnIndex === 5) {
        if (rowIndex === 0) {
          return [len, 1]
        } else {
          return [0, 0]
        }
      }
    },
    getList () {
      this.$nextTick(() => {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.getIsCanReBook()
            const param = {
              orderNo: this.listQuery.orderNo || null,
              page: this.listQuery.page,
              limit: this.listQuery.limit,
              useStartDateStart: this.listQuery.orderTime ? this.listQuery.orderTime + ' 00:00:00' : null,
              useStartDateEnd: this.listQuery.orderTime ? this.listQuery.orderTime + ' 23:59:59' : null,
              visitorCertificateNo: this.listQuery.visitorCertificateNo || null,
              contactMobile: this.listQuery.contactMobile || null,
              orderStatus: this.listQuery.orderStatus || null
            }
            page(param).then(response => {
              this.listLoading = false
              if (response.code === 0) {
                response.data.list.forEach(item => {
                  if (item.tripOrderDetailDOList && item.tripOrderDetailDOList.length > 0) {
                    item.tripOrderDetailDOList = item.tripOrderDetailDOList.filter(val => val.quantity !== 0) // 数量为0改签前，不展示数据
                  }
                })
                this.list = response.data.list
                this.total = response.data.totalCount
              } else {
                this.$message.error('请求出错了')
              }
            })
          }
        })
      })
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      let index = this.list.findIndex(item => item.orderNo === row.orderNo)
      let len = this.list[index].tripOrderDetailDOList.length
      if (columnIndex === 6 || columnIndex === 7) {
        if (rowIndex === 0) {
          return [len, 1]
        } else {
          return [0, 0]
        }
      }
    },
    handleTab (inx) {
      this.listQuery.page = 1
      this.currentIndex = inx
      switch (inx) {
        case 0:
          this.listQuery.orderStatus = null
          break
        case 1:
          this.listQuery.orderStatus = '60'
          break
        case 2:
          this.listQuery.orderStatus = '20'
          break
      }
      this.getList()
    },
    // 购买补票
    payReplenish () {
      // 保存订单
      var data = {
        orderNo: this.replenishList[0].orderNo,
        replenishTicketList: this.replenishSelectedList.map(item => { return { ticketNo: item.ticketNo } })
      }
      // 修改字段再发送，用于支付页面显示
      this.replenishSelectedList.forEach(item => {
        item.salePrice = item.replenishTicketDiffPrice
        item.selectNum = 1
      })
      saveReplenishOrder(data).then(res => {
        // 跳转到支付页
        this.$router.push({
          path: '/payOrder',
          query: {
            orderNo: res.data.orderNo,
            goodsNum: this.replenishSelectedList.length,
            ticketList: JSON.stringify(this.replenishSelectedList),
            isReplenishOrder: true,
            reservationMsg: `${this.replenishList[0].useStartDate} ${this.replenishList[0].reservationBeginTime}-${this.replenishList[0].reservationEndTime}`
          }
        })
      })
    },
    // 补票
    replenish (orderNo) {
      // 显示补票弹窗
      this.replenishDialogVisible = true
      this.getReplenishList(orderNo)
    },
    // 获取补票列表
    getReplenishList (orderNo) {
      // 加载
      this.replenishListLoading = true
      // 清空
      this.replenishList = []
      var params = {
        orderNo: orderNo
      }
      getReplenishList(params).then((res) => {
        this.replenishListLoading = false
        if (res.code !== 0) {
          this.$message.error('请求出错了!')
          return
        }
        this.replenishList = res.data
      })
    },
    // 支付
    hanleToPay (orderNo, item) {
      // 支付查询
      PayForTheQuery(orderNo).then(res => {
        if (res.code === 0) {
          if (res.data === 'PAID') {
            this.$confirm('订单已支付', '支付查询', {
              showCancelButton: false,
              confirmButtonText: '确定'
            })
            return
          }
          let ticketList = item.tripOrderDetailDOList
          let goodsNum = 0
          ticketList.forEach(item => {
            item.salePrice = item.currentSalePrice
            item.selectNum = item.quantity
            goodsNum += item.quantity
          })
          this.$router.push({
            path: 'payOrder',
            query: {
              orderNo,
              ticketList: JSON.stringify(ticketList),
              goodsNum
            }
          })
        } else {
          this.$message.error(res.error)
        }
      })
    },
    refundInit () {
      this.refunfPrice = 0
      this.refundReplenishOriginPrice = 0
      this.refundPoundage = 0
      this.isReplenishOrder = false
      this.selectionList = []
      this.tikcetInfoList = []
    },
    // 退款
    hanleToRefund (orderNo) {
      this.visitorCertificateNo = null
      this.orderNo = orderNo
      this.ticketInfo = {}
      const data = {
        orderNo,
        isNeedPoundage: 'T',
        isSpecialReturn: 'F'
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.3)'
      })
      this.refundInit()
      getTicketInfo(data).then(response => {
        loading.close()
        if (response.code === 0) {
          this.ticketInfo = response.data
          if (this.ticketInfo) {
            this.ticketInfo.tikcetInfoList = this.ticketInfo.tikcetInfoList.filter(item => item.isReplenished === 'F')
            if (this.ticketInfo.tikcetInfoList) {
              this.tikcetInfoList = this.ticketInfo.tikcetInfoList.map(item => {
                if (item.isReplenishTicket === 'T') this.isReplenishOrder = true
                for (const ot of this.status) {
                  if (ot.code === item.status) {
                    item.status = ot.value
                    break
                  }
                }
                item.originTicketInfo = null
                var originTicketInfoList = this.ticketInfo.originalTicketInfoList.filter(item1 => {
                  return item1.visitorCertificateNo === item.visitorCertificateNo
                })
                if (originTicketInfoList.length > 0) {
                  item.originTicketInfo = originTicketInfoList[0]
                }
                return item
              })
              this.refunfPrice = 0
              this.refundReplenishOriginPrice = 0
              this.refundPoundage = 0
              this.dialogCompVisible = true
            } else {
              this.$message.warning('暂无可退款的票')
            }
          } else {
            this.$message.warning('暂无可退款的票')
          }
        } else {
          this.$message.error('请求出错了')
        }
      })
    },
    submitReBook () {
      if (this.clickFlag) {
        return
      }
      const timeSharing = this.timeSharing.filter(val => val.isCheck === true)
      if (timeSharing.length === 0) {
        this.$message.warning('请选择检票进场时段')
        return false
      }
      const rebookTikcetDetails = []
      this.selectionTicketList.forEach(item => {
        rebookTikcetDetails.push({
          staggeredReservationDailyId: timeSharing[0].id,
          ticketNo: item.ticketNo,
          useStartDate: this.selectDate + ' 00:00:00'
        })
      })
      const data = {
        rebookTikcetDetails,
        orderNo: this.reOrderNo
      }
      this.clickFlag = true
      canReBook(data).then(res => {
        this.clickFlag = false
        if (res.code === 0) {
          this.$message.success('改签票成功')
          this.dialogTimeVisible = false
          this.selectionTicketList = []
          this.timeSharing = []
          this.getList()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    submitEndorse () {
      if (this.selectionTicketList.length === 0) {
        this.$message.warning('请选择要改签的票')
        return false
      }
      this.dialogTicketVisible = false
      this.dialogTimeVisible = true
      const tempDate = new Date()
      const acquired = new Date()
      this.getPreSaleDays().then(res => {
        this.presaledays = res
        console.log(this.presaledays)
        if (this.presaledays) {
          var _this = this
          tempDate.setDate(tempDate.getDate())
          acquired.setDate(acquired.getDate() + this.presaledays)
          let date = [{
            title: dateFtt('MM-dd', tempDate),
            currentDate: false,
            postDate: dateFtt('yyyy-MM-dd', tempDate)
          }, {
            title: dateFtt('MM-dd', acquired),
            currentDate: false,
            postDate: dateFtt('yyyy-MM-dd', acquired)
          }]
          this.dateList = date
          this.pickerOptions = {
            disabledDate (time) {
              const curDate = (new Date()).getTime() - (1 * 24 * 3600 * 1000)
              // 这里算出一个月的毫秒数,
              const day = (_this.presaledays) * 24 * 3600 * 1000
              const dateRegion = curDate + day
              return time.getTime() < curDate || time.getTime() > dateRegion
            }
          }
          this.getReservationConfig()
        }
      })
    },
    /**
   * @description: 查询日期是否开始分时段预约，开启时继续查询当天全部时段数据，未开启分时段预约时直接查询当天可售列表数据
   */
    getReservationConfig () {
      const data = {
        orgId: sessionStorage.getItem('orgId')
      }
      reservationConfig(data).then(res => {
        if (res.code === 0) {
          this.ReservationConfig = res.data
          // 是否开启分时段预约
          if (res.data.isSaleStaggered === 'T') {
            // 查询预约余票量
            this.standByList()
          } else {
            this.timeSharingIndex = null
          }
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    /**
     * @description: 查询固定时间余票量和是否停用
     */
    standByList () {
      console.log(this.dateList)
      const data = {
        orgId: sessionStorage.getItem('orgId'),
        beginDate: this.dateList[0].postDate,
        endDate: this.dateList[1].postDate
      }
      standByList(data).then(res => {
        if (res.code === 0) {
          let arr = []
          arr = res.data.sort(function (a, b) { return a.date > b.date ? 1 : -1 })
          arr.forEach((item, index) => {
            item.showDate = item.date.split('-')
          })
          let ids = res.data.findIndex((value) => (value.canReservationSanke === 'T'))
          if (ids > -1) {
            arr.forEach((item, index) => {
              if (index === ids) {
                item.isCheck = true
                this.selectDate = item.date
                if (ids >= 3) {
                  this.valueDate = item.date
                }
              } else {
                item.isCheck = false
              }
            })
            this.getstaggeredList()
          }
          this.date = arr
        } else if (res.code === 1017) {
          this.$message({
            message: '登录过期，安全性提醒：请重新登录',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    submitReplenishRefund () {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择要退款的票')
        return
      }
      const refundTikcetDetails = this.selectionList.map(item => ({
        ticketNo: item.ticketNo
      }))
      const refundOriginTikcetDetails = this.selectionList.map(item => ({
        ticketNo: item.originTicketInfo.ticketNo
      }))
      var refundList = []
      if (refundTikcetDetails.length > 0) {
        refundList.push({
          originalOrderNo: this.ticketInfo.tripOrderForRefundVO.orderNo,
          outRefundOrderNo: this.ticketInfo.tripOrderForRefundVO.outOrderNo,
          isNeedPoundage: 'T',
          isSpecialReturn: 'F',
          refundTikcetDetails: refundTikcetDetails
        })
      }
      if (refundOriginTikcetDetails.length > 0) {
        refundList.push({
          originalOrderNo: this.selectionList[0].originTicketInfo.orderNo,
          outRefundOrderNo: this.selectionList[0].originTicketInfo.outOrderNo,
          isNeedPoundage: 'T',
          isSpecialReturn: 'F',
          refundTikcetDetails: refundOriginTikcetDetails
        })
      }
      const data = {
        tripOrderRefundCreateDTOList: refundList
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.3)'
      })
      ticketReplenishRefund(data).then(res => {
        loading.close()
        this.dialogCompVisible = false
        if (res.code === 0) {
          this.$message.success('申请成功')
          this.getList()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    submitRefund () {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择要退款的票')
        return
      }
      const refundTikcetDetails = this.selectionList.map(item => ({
        poundAge: item.refundPoundage,
        ticketNo: item.ticketNo
      }))
      const data = {
        originalOrderNo: this.ticketInfo.tripOrderForRefundVO.orderNo,
        outRefundOrderNo: this.ticketInfo.tripOrderForRefundVO.outOrderNo,
        isNeedPoundage: 'T',
        isSpecialReturn: 'F',
        refundTikcetDetails
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.3)'
      })
      ticketRefund(data).then(res => {
        loading.close()
        this.dialogCompVisible = false
        if (res.code === 0) {
          this.$message.success('申请成功')
          this.getList()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    handleSelectionChange (val) {
      this.selectionList = val
      let refunfPrice = 0
      let refundPoundage = 0
      let refundReplenishOriginPrice = 0
      val.forEach(item => {
        refundReplenishOriginPrice += Number(item.originTicketInfo ? item.originTicketInfo.paymentAmount : 0)
        refunfPrice += Number(item.totalPrice)
        refundPoundage += Number(item.refundPoundage)
      })
      this.refundReplenishOriginPrice = refundReplenishOriginPrice.toFixed(2)
      this.refundPoundage = refundPoundage.toFixed(2)
      this.refunfPrice = (refunfPrice - refundPoundage).toFixed(2)
    },
    handleSelectionTicketChange (val) {
      this.selectionTicketList = val
    },
    // 查看审核失败原因
    hanleToReason (msg) {
      this.$alert(msg, '审核失败原因', {
        confirmButtonText: '确定'
      })
    },
    // 订单详情
    hanleToDetail (orderNo) {
      this.orderNoDetail = orderNo
      this.orderDetailShow = true
    },
    toPath (path) {
      console.log(path)
      this.$router.push(path)
    },
    reset (name) {
      this.$refs[name].resetFields()
      this.currentIndex = 0
      this.listQuery.orderStatus = null
    },
    tempObj () {
      const data = {
        orderTimeEnd:
          this.listQuery.orderTime
            ? this.listQuery.orderTime + ' 00:00:00'
            : null,
        orderTimeStart:
          this.listQuery.orderTime
            ? this.listQuery.orderTime + ' 23:59:59'
            : null,
        orderNo: this.listQuery.orderNo || null,
        contactCertificateNo: this.listQuery.contactCertificateNo || null,
        contactMobile: this.listQuery.contactMobile || null,
        tripCertificateNo: this.listQuery.tripCertificateNo
      }
      return data
    },
    handleReset (formName) {
      this.$refs[formName].resetFields()
    },
    hanleReOrder (orderNo) {
      this.$router.push({
        path: 'productBook',
        query: {
          orderNo
        }
      })
    },
    handleTikcetInfoListFilter () {
      if (!this.visitorCertificateNo.trim()) {
        this.hanleToRefund(this.orderNo)
        return
      }
      const tikcetInfoList = this.tikcetInfoList.filter(item => item.visitorCertificateNo === this.visitorCertificateNo.trim())
      this.tikcetInfoList = tikcetInfoList
    },
    backAndClose () {
      this.orderDetailShow = false
    },
    payQuery (orderNo) {
      PayForTheQuery(orderNo).then(res => {
        console.log(res)
        if (res.code === 0) {
          if (res.data === 'UNPAID') {
            this.$confirm('订单未支付或者系统异常', '支付查询', {
              showCancelButton: false,
              confirmButtonText: '确定'
            })
            return
          }
          if (res.data === 'PAID') {
            this.$confirm('出票成功', '支付查询', {
              showCancelButton: false,
              confirmButtonText: '确定'
            })
            return
          }
          this.$confirm(res.error, '支付查询', {
            showCancelButton: false,
            confirmButtonText: '确定'
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.myOrder{
  width: 1280px;
  background: white;
  margin: 0 auto;
  padding: 40px;
  min-width: 1230px;
}
.order-table{
    .el-table__header-wrapper{
        thead {
            th{
                color: #3d3d3d;
                font-weight: bold;
                // background: red;
            }
        }
    }
    .el-table__body-wrapper{
        .el-table__row{
            background: #F1F6FF;
        }
        .el-table__expanded-cell{
            padding: 0;
            thead {
              th{
                color: #3d3d3d;
              }
            }
            .el-table__row{
              background: #fff;
            }
        }
        .el-table--enable-row-hover .el-table__body tr:hover>td{
            background: #fff;
        }
    }
}
.footer-box {
  display: flex;
  .travel-refundTotal{
    line-height: 32px;
    font-size: 14px;
    color: #666;
    text-align: left;
    flex: 10;
    .travel-tip {
      font-size: 20px;
      color: #aa7777;
      font-weight: 700;
      margin-right: 5px;
    }
    .travel-tip-right {
      margin-left: 5px;
    }
  }
  .footer-btn {
    flex: 2;
    text-align: right;
  }
}
.calendar-list-container{
  margin: 0 auto;
  .title {
    position: relative;
    font-size: 18px;
    line-height: 65px;
    padding-left: 25px;
    font-weight: bold;
  }
  .tab-box {
    overflow: hidden;
    margin-bottom: 10px;
    background: #F1F6FF;
  .back {
    float: right;
    border-radius: 6px;
  }
  span {
    float: left;
    width: 130px;
    height: 44px;
    cursor: pointer;
    color: #8791A5;
    font-size: 16px;
    margin-right: 2px;
    text-align: center;
    line-height: 44px;
    &.active {
      border-bottom: 2px solid #3987E1;
      color: #3987E1;
    }
  }
}
}
.mr10 {
  margin-right: 10px;
}
.cursor{
  cursor: pointer;
}
.div-ticket {
  overflow: hidden;
  .buyticket-div {
    overflow: hidden;
    margin-bottom: 19px;
    .title {
      float: left;
      font-size: 16px;
      color: #333;
      font-weight: bold;
      line-height: 44px;
      height: 44px;
    }
    .buyticket-right {
      overflow: hidden;
      padding-left: 100px;
      // height: 44px;
      .select-list {
        float: right;
        text-align: right;
        > span {
          display: inline-block;
          margin: 0 7px;
          width: 130px;
          min-height: 44px;
          border-radius: 6px;
          font-size: 16px;
          color: #333;
          text-align: center;
          line-height: 44px;
          cursor: pointer;
          margin-bottom: 10px;
          > em {
            display: inline-block;
            width: 100%;
            height: 100%;
            line-height: 26px;
            border-radius: 6px;
            overflow: hidden;
            font-style: normal;
            background: rgba(246, 246, 246, 1);
            padding: 6px 0;
            &:hover {
              opacity: 0.8;
            }
            &.active {
              background: #241008;
              color: #fff;
            }
            &.disable {
              color: #cdcdcd;
              cursor: no-drop;
            }
          }
        }
      }
      .time-select-text {
        line-height: 44px;
        color: #ec2f2f;
      }
      .select-btn {
        float: right;
        width: 130px;
        height: 44px;
        line-height: 44px;
        border-radius: 6px;
        .input-show {
          display: block;
          width: 100%;
          height: 100%;
          line-height: 44px;
          text-align: center;
          height: 44px;
          background: #f6f6f6;
          border-radius: 6px;
          font-size: 16px;
          color: #333;
          text-align: center;
          line-height: 44px;
          cursor: pointer;
          outline: none;
          text-align: center;
          &.active {
            background: #241008;
            color: #fff;
          }
          &:hover {
            opacity: 0.8;
          }
        }
        .picker-options {
          display: block;
          width: 100%;
          height: 44px;
          line-height: 44px;
          .el-input {
            width: 100% !important;
            background: #f6f6f6;
          }
        }
      }
      .buyticket-list {
      }
    }
  }
  .buyticket-footer {
    overflow: hidden;
    display: flex;
    border-top: 1px solid #f6f6f6;
    padding-top: 29px;
    margin-top: 31px;
    .booking-notice {
      flex: 1;
      height: 58px;
      line-height: 58px;
      img {
        display: inline-block;
        width: 16px;
        height: 16px;
        vertical-align: middle;
        margin-right: 4px;
        cursor: pointer;
      }
      span {
        display: inline-block;
        font-size: 16px;
        color: #ec2f2f;
        vertical-align: middle;
        cursor: pointer;
      }
    }
    .booking-msg {
      flex: 1;
      overflow: hidden;
      line-height: 58px;
      text-align: right;
      .msg {
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
        color: #333;
        span {
          display: inline-block;
          color: #ff4400;
          margin: 0 12px;
        }
      }
    }
  }
}
.btns {
  span {
    display: inline;
  }
}
</style>
